import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';

interface Payload {
  /** Present when editing; absent when creating. */
  id?: string;
  name: string;
  clinicIds: string[];
  userIds: string[];
}

/** Create or update a clinic group. Super admin only (enforced server-side). */
export const saveClinicGroupApi = createAsyncThunk(
  'clinicGroups/save',
  async ({ id, ...body }: Payload, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: id ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify(body),
      };

      const res = await fetch(id ? CLINICS.CLINIC_GROUP_URL(id) : CLINICS.CLINIC_GROUPS_URL, requestOptions);

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to save clinic group');
      }

      return await res.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
